export default function ContactHero(props: { heading: string; subheading: string }) {
  return (
    <section className='h-100% w-screen flex flex-col justify-center items-center bg-landing bg-cover bg-no-repeat bg-center py-16'>
      <p className='text-white text-3xl sm:text-5xl font-black tracking-wider mb-4'>
        {props.heading}
      </p>
      <p className='text-white text-lg sm:text-xl font-medium tracking-wide text-center max-sm:px-4'>
        {props.subheading}
      </p>
    </section>
  )
}
